<template>
  <div class="GlobalTable">
    <GlobalTable
      ref="GlobalTable"
      v-loading="loading"
      :columns="tableColumns"
      :data="this.seachDataList"
      :currentPage="page.pageNum"
      :total="page.total"
      @handleCurrentChange="handleCurrentChange"
    >
      <el-table-column label="发货订单" slot="parcelQuantity" align="center">
        <template slot-scope="{ row }">
          <span style="color: #0981ff; cursor: pointer" @click="fahuo(row)">
            {{ row.allCount }}</span
          >
        </template>
      </el-table-column>
        <el-table-column label="门店商家" slot="senderCompanyName" align="center">
        <template slot-scope="{ row }">
          <span >
            {{ row.senderCompanyName || "--" }}</span
          >
        </template>
      </el-table-column>

           <el-table-column label="发货门店" slot="senderStoreName" align="center">
        <template slot-scope="{ row }">
          <span >
            {{ row.senderStoreName || "--" }}</span
          >
        </template>
      </el-table-column>

        <el-table-column label="发货快递" slot="expressCode" align="center">
        <template slot-scope="{ row }">
          <span >
            {{ row.expressCode == 'jd' ? '京东物流' : '顺丰物流' }}</span
          >
        </template>
      </el-table-column>

        <el-table-column label="发货人" slot="senderName" align="center">
        <template slot-scope="{ row }">
            <span class="channeltype2">
             {{row.senderIsMajor ?'创建人':row.senderType == '01' ? '子账号' : row.senderType == '02'? '总监' : row.senderType == '03' ? '店长' : '店员'}}
           </span>
          <span >
            {{ row.senderName || "--" }}</span
          >
        </template>
      </el-table-column>

      <el-table-column
        width="200"
        label="发货总价值"
        slot="allCost"
        align="center"
      >
        <template slot-scope="{ row }">
          <span>{{ row.allCost }}元</span>
        </template>
      </el-table-column>

      <el-table-column width="200" label="物流状态" slot="state" align="center">
        <template slot-scope="{ row }">
          <span>{{
            row.state == "2" ? "运输中" : row.state == "6" ? "已完成" : "已取消"
          }}</span>
        </template>
      </el-table-column>
      <el-table-column width="100" label="物流费用" slot="allFee" align="center">
        <template slot-scope="{ row }">
          <span v-if="row.allFee">￥{{row.allFee}}</span>
          <span v-else>--</span>
        </template>
      </el-table-column>
      <el-table-column width="200" label="操作" slot="operation" align="center">
        <template slot-scope="{ row }">
          <el-button size="mini" type="primary" round @click="handleBtn(row)"
            >查看物流详情</el-button
          >
        </template>
      </el-table-column>
    </GlobalTable>
    <!-- 备注弹出框 -->
    <!--弹框-->

    <el-dialog
      class="acc_dialog"
      title="物流详情"
      :visible.sync="Logisticsdetails"
      :close-on-click-modal="false"
      width="810px"
    >
      <div v-loading="loading2">
        <div class="fzs18 b25">快递单号：{{ Logisticsarray.expressNo }}</div>

        <div
          style="
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            margin-bottom: 10px;
          "
        >
          <div class="one">
            <div class="fzs18 b03">{{ Logisticsarray.senderCompanyName }}</div>
            <div class="fzs14">{{ Logisticsarray.senderStoreName }}</div>
          </div>

          <div class="one_img">
            <img
              src="../../assets/images/jiantouleft.png"
              style="width: 38px;height: 11px;"
              alt=""
            />
          </div>

          <div class="one">
            <div class="fzs18 b03">
              {{ Logisticsarray.receiverMerchantName }}
            </div>
            <!-- <div class="fzs14">太升南路十号店</div> -->
          </div>
        </div>

        <div
          style="
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 10px;
          "
        >
          <div class="two">
            <div class="twoinfo">寄件人信息</div>
            <div class="twophone">
              {{ Logisticsarray.senderName }}-{{ Logisticsarray.senderMobile }}
            </div>
            <div>{{Logisticsarray.senderAddress +  Logisticsarray.senderAddressDetail }}</div>
          </div>
          <div class="two">
            <div class="twoinfo">收件人信息</div>
            <div class="twophone">
              {{ Logisticsarray.receiverName }}-{{
                Logisticsarray.receiverMobile
              }}
            </div>
            <div>{{Logisticsarray.receiverAddress +  Logisticsarray.receiverAddressDetail }}</div>
          </div>
        </div>

        <div class="loacinfo">物流信息</div>

        <div class="three">
          <el-timeline
            v-if="
              this.Logisticsarray.logistics &&
              this.Logisticsarray.logistics.length
            "
          >
            <el-timeline-item
              v-for="(activity, index) in Logisticsarray.logistics"
              :key="index"
              :timestamp="activity.opeRemark"
            >
              {{ activity.opeTime }}
            </el-timeline-item>
          </el-timeline>
          <el-empty
            v-else
            style="margin-top: -40px"
            description="暂无物流信息"
          ></el-empty>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click.native="Logisticsdetails = false">关闭</el-button>
      </span>
    </el-dialog>

    <el-dialog
      class="allot-dialog"
      title="订单列表"
      :visible.sync="handleShow"
      :close-on-click-modal="false"
      width="980px"
      @closed="allotDialogClosed"
    >
      <GlobalForm
        class="global-form"
        :init-data="initData"
        :form-item-list="redenvelopeslist"
        :inline="true"
        :labelWidth="100"
        round
        @handleConfirm="redenvelopeslistFn"
        confirmBtnName="查询"
      >
        <!-- <el-button
          icon="el-icon-download"
          slot="AddSlot"
          type="primary"
          @click="exportExcel"
          >导出Excel</el-button
        > -->
      </GlobalForm>

      <GlobalTable
        ref="GlobalTable"
        v-loading="loading3"
        :columns="redenvelopeslisttitle"
        :data="this.redenvedata"
        :currentPage="page3.pageNum"
        :total="page3.total"
        @handleCurrentChange="redenvellistFn"
      >
       <el-table-column label="订单状态" slot="state" align="center">
        <template slot-scope="{ row }">
         <span>
                <span
          >{{
           row.state == "00"
              ? "待确认"
              : row.state == "01"
              ? "已确认"
              : row.state == "02"
              ? "待支付"
              : row.state == "03"
              ? "已绑码"
              : row.state == "04"
              ? "已收货"
              : row.state == "05"
              ? "降价收货"
              : row.state == "10"
              ? "已取消"
              : row.state == "20"
              ? "已作废"
              : "已退回"
          }}</span
        >
         </span>
        </template>
      </el-table-column>
      <el-table-column label="补充发货凭证" slot="supplement" align="center">
          <template slot-scope="{ row }">
            <div class="images-box" v-if="row.deliverGoodImages.length>0">
              <img :src="row.deliverGoodImages[0].sampleImage" alt="" />
              <span @click="openImgBox1(row)" class="text-down">共<span>{{
                row.deliverGoodImages.length
                  }}</span>
                张</span>
            </div>
            <div v-if="row.deliverGoodImages.length==0" class="column">
              <span>未上传凭证</span>
            </div>
          </template>
        </el-table-column>
      <el-table-column label="操作" slot="caozuo" align="center">
        <template slot-scope="{ row }">
          <el-button size="mini" type="primary" round @click="goDetails(row)"
            >订单详情</el-button
          >
        </template>
      </el-table-column>
      </GlobalTable>
      <!-- 入账区域END -->
    </el-dialog>
     <!-- 补充发货凭证 -->
     <el-dialog :close-on-click-modal="false" :width="`${800}px`" title="查看发货拍照图片" :visible="supplementimg" @close="imgClose1"
      top="5%">
      <div class="img-box">
        <div class="img-tips-box">
          <div class="img-tips img-tips-default" style="width: 90px;">
           补充发货凭证
          </div>
        </div>
        <div class="img-show">
          <div class="imgs-num" v-if="DialogImgList1.length > 0">
            {{ imgShowIndex1 + 1 }}/{{ DialogImgList1.length }}
          </div>
          <div class="block">
            <el-carousel trigger="click" height="80vh" @change="getindex1">
                <el-carousel-item v-for="(item,index) in DialogImgList1" :key="index">
                  <div class="sec_img">
                    <img :src="item.sampleImage" alt="" class="imgitem" />
                  </div>
                </el-carousel-item>
              </el-carousel>
          </div>
          <div style="margin-top: 10px;" v-if="DialogImgList1.length > 0">
            <span style="font-weight: bold;color: #333;margin-right: 10px;">{{ DialogImgList1[imgShowIndex1].phoneName }}</span><span style="margin-right: 10px;color: rgb(9, 129, 255);cursor: pointer;text-decoration: underline;" @click="sendDtailClick(DialogImgList1[imgShowIndex1].orderno)">{{ DialogImgList1[imgShowIndex1].orderno }}</span><span style="margin-right: 10px;color: #333;">IMEI:{{ DialogImgList1[imgShowIndex1].imei }}</span><span style="color: #333;">上传时间:{{ DialogImgList1[imgShowIndex1].createTime }}</span>
          </div>
          <!-- <LookImg :images="imgList"/> -->
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import _api from "@/utils/request";
import moment from "moment";
export default {
  name: "Table",
  data() {
    return {
      initData: null,
      redenvelopeslisttitle: [
        { label: "订单编号", prop: "orderNo" },
        { label: "成交商家报价（元）", prop: "quotePrice" },
        { label: "下单店员", prop: "staffName" },
        { label: "繁星码", prop: "barCode" },
        // { label: "订单状态", prop: "state" },
            { slotName: "state" },
            {slotName:"supplement"},
        { slotName:"caozuo" },
    
      ],
      loading3: false,
      redenvedata: [],
      page3: {
        pageNum: 1,
        total: 0,
      },
      redenvelopeslist: [
        {
          key: "orderNo",
          type: "input",
          labelName: "订单编号",
          placeholder: "请输入订单编号",
        },
        {
          key: "barCode",
          type: "input",
          labelName: "繁星码",
          placeholder: "请输入繁星码",
        },
      ],
      handleShow: false,
      loading: false,
      seachDataList: [],
      auditStatus: "00",
      auditStatusRadio: "",
      butLoading: false,
      enableButLoading: false,
      page: {
        pageNum: 1,
        pageSize: 10,
      },
      tableColumns: [
        { label: "回收商家", prop: "receiverMerchantName" },
        // { label: "门店商家", prop: "senderCompanyName" },
        { slotName: "senderCompanyName" },

        // { label: "发货门店", prop: "senderStoreName" },
        { slotName: "senderStoreName" },

        { slotName: "expressCode" },

        { label: "物流单号", prop: "expressNo" },
        { label: "物流下单时间", prop: "createTime" },
        { slotName: "parcelQuantity" },
        // { label: "旧机数量/总价值", prop: "allCost" },
        { slotName: "allCost" },
        { slotName: "senderName" }, //发货人
        { label: "发货人电话", prop: "senderMobile" },
        // { label: "物流状态", prop: "state" },
        { slotName: "state" },
        { slotName: "allFee" },
        { slotName: "operation" }, //操作
      ],
      // 弹框
      RemarksTitle: "",
      applyTitle: "",
      command: "",
      auditNote: "",
      monthSettlementAccount: "",
      RemarksShow: false,
      enableShow: false,
      applyDialogVisible: false,
      enableTitle: "",
      masterNote: "",
      setDialogVisible: false,
      rulesInfo: {},
      expressList: [],
      businessVisible: false,
      DialogTableColumns: [
        { label: "门店商家", prop: "companyName" },
        { label: "联系人", prop: "contact" },
        { label: "联系电话", prop: "phone" },
        { slotName: "companyIsEnable" },
        { slotName: "isLogisticsConfig" },
      ],
      DialogDataList: [],
      dialogPage: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
      isEnable: "",
      applyRecord: {},
      Logisticsdetails: false,
      Logisticsarray: {},
      loading2: false,
      iiicd:'',
      arr:{},
      initexpressNo:'',
      supplementimg:false,
      DialogImgList1:[],
      imgShowIndex1:0
    };
  },
  created() {
         let expressNo =   this.$route.query.id;
 console.log(expressNo);
 if(expressNo){
   this.initexpressNo = expressNo;
 }

    let startTime = moment()
                .day(moment().day() - 6)
                .format("YYYY-MM-DD 00:00:00"); // 当前时间往前推15天的时间
    let endTime = moment().format("YYYY-MM-DD 23:59:59");
            startTime = Date.parse(startTime);
            endTime = Date.parse(endTime);
            this.entryTime = [startTime, endTime];
    this.handleCurrentChange();
  },
  computed: {
    SeachParams() {
      return this.$store.state.tagsView.SeachParams;
    },
  },
  watch: {
    SeachParams(newVal) {
      console.log(newVal);
      this.page.pageNum = 1;
      this.handleCurrentChange();
    },
  },
  methods: {
       // 订单详情
    goDetails(row) {
      let routeData = this.$router.resolve({
        path: "/RecallOrder/Details",
        query: { type: "edit", id: row.orderNo },
      });
      window.open(routeData.href, "_blank");
    },
    allotDialogClosed() {},
    redenvellistFn(val) {
      var pageNum = val ? val : 1;
     
      this.redenvelopeslistFn(this.arr,pageNum)
    },
    redenvelopeslistFn(data,pageNum) {
      this.arr = data;
        let params = {orderNo:data.orderNo,barCode:data.barCode,expressNo:this.iiicd,pageNum :pageNum || 1,pageSize:10}
      _api.getOrderListByExpressNo(params).then(res=>{
        console.log(res);
        this.redenvedata = res.data.records;
        this.page3.pageNum = res.data.current;
        this.page3.total = res.data.total;
      })
    },
    fahuo(row) {
      this.handleShow = true;
      this.iiicd = row.expressNo;
      let params = {orderNo:'',barCode:'',expressNo:row.expressNo}
      _api.getOrderListByExpressNo(params).then(res=>{
        console.log(res);
        this.redenvedata = res.data.records;
        this.page3.pageNum = res.data.current;
        this.page3.total = res.data.total;
      })
    },
    // 表格切换页面
    handleCurrentChange(val) {
      if (val) {
        this.page.pageNum = val;
      }
      const baseRequest = {
        merchantId: this.SeachParams.merchantId,
        storeId: this.SeachParams.storeId,
        expressNo: this.SeachParams.expressNo ? this.SeachParams.expressNo  : this.initexpressNo ? this.initexpressNo : '',
        staffName: this.SeachParams.staffName,
        state: this.SeachParams.state,
        startTime: this.SeachParams.startTime || this.entryTime[0],
        endTime: this.SeachParams.endTime || this.entryTime[1],
        pageNum: this.page.pageNum,
        pageSize: this.page.pageSize,
        expressCode:this.SeachParams.expressCode
      };
      this.loading = true;
      _api.getExpressOrders(baseRequest).then((res) => {
        if (res.code === 1) {
          this.seachDataList = res.data.records;
          this.page.total = res.data.total;
          this.page.pageNum = res.data.current;
          this.loading = false;
          this.initexpressNo = '';
        }
        if (typeof this.SeachParams.disuseLoding === 'function') {
          this.SeachParams.disuseLoding();
        }
      }).catch(() => {
        if (typeof this.SeachParams.disuseLoding === 'function') {
          this.SeachParams.disuseLoding();
        }
      });
    },
    remarksClosed() {
      this.RemarksShow = false;
      this.masterNote = "";
    },
    // 弹出弹框
    handleBtn(row) {
      this.loading2 = true;
      this.Logisticsdetails = true;

      _api.logisticsInfo({ expressNo: row.expressNo }).then((res) => {
        console.log(res);
        this.Logisticsarray = res.data;
        this.loading2 = false;
      });
    },
    //合作回收商家
    handleCurrentChangeDialog(val) {},
    onClose() {},
    openImgBox1(row) {
      this.supplementimg = true;
        let arry=[]
        for (let i=0;i<row.deliverGoodImages.length;i++){
          arry.push({
            phoneName:row.phoneName,
            orderno:row.orderNo,
            orderUnique:row.orderUnique,
            createTime:row.deliverGoodImages[i].createTime,
            sampleImage:row.deliverGoodImages[i].sampleImage,
            imei:row.imei
          })
        }
        this.DialogImgList1 = arry
    },
    getindex1(e) {
      console.log(e);
      this.imgShowIndex1 = e;
    },
    imgClose1() {
      console.log(1);
      this.supplementimg = false;
    },
    sendDtailClick(row) {
      let routeData = this.$router.resolve({
        path: "/RecallOrder/Details",
        query: { type: "edit", id: row },
      });
      window.open(routeData.href, "_blank");
    },
  },
};
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.GlobalTable {
  // 备注说明
  .Remarks {
    width: 100%;
    height: 100%;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2; //控制行数
    overflow: hidden;
  }
  .operation-btn {
    /deep/.el-button {
      margin-left: 0;
    }
  }
  .button_top {
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .faultBtn {
    width: 500px;
    height: 34px;
    background: #f9fbfd;
    border: 1px solid #c1d1ff;
    box-shadow: 0px 4px 8px 0px rgba(196, 197, 198, 0.2);
    border-radius: 21px;
    display: flex;
    cursor: pointer;
    .active {
      text-align: center;
      color: white;
      width: 50%;
      height: 14px;
      font-size: 14px;
      font-family: FZLanTingHei-M-GBK;
      font-weight: 400;
      line-height: 32px;
      height: 32px;
      background: #0981ff;
      border-radius: 20px;
    }
    .none {
      text-align: center;
      color: #333;
      width: 50%;
      height: 14px;
      font-size: 14px;
      font-family: FZLanTingHei-M-GBK;
      font-weight: 400;
      line-height: 32px;
      height: 32px;
      border-radius: 20px;
    }
  }
  .verify-title {
    color: #0981ff;
    line-height: 16px;
    font-size: 16px;
    padding-left: 10px;
    border-left: 3px solid;
    margin-bottom: 10px;
  }
  .enable-tip {
    color: #ff8080;
    font-size: 14px;
    margin-bottom: 20px;
    .tip-sure {
      margin-top: 10px;
      color: #333333;
      font-size: 16px;
      text-align: center;
    }
  }
  .command {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }
  .mb-10 {
    margin-bottom: 10px;
  }
  .mb-20 {
    margin-bottom: 20px;
  }
  .mr-50 {
    margin-right: 50px;
  }
  .ml-10 {
    margin-left: 10px;
  }
  .mr-10 {
    margin-right: 10px;
  }
  .font-w {
    font-weight: bold;
  }
  .flex {
    display: flex;
    align-items: center;
  }
  .flex-jb {
    display: flex;
    justify-content: space-between;
  }
  .flex-as {
    display: flex;
    align-items: flex-start;
  }
}
.one {
  flex: 1;
  text-align: center;
}
.one_img {
  width: 38px;
  height: 11px;
}
.fzs18 {
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: bold;
}
.b25 {
  margin-bottom: 15px;
}
.fzs14 {
  font-size: 14px;
  font-family: FZLanTingHei-M-GBK;
  font-weight: 400;
  color: #666666;
}
.b03 {
  margin-bottom: 3px;
}
.two {
  max-height: 124px;
  background: #f5f6fa;
  border-radius: 6px;
  width: 360px;
  padding: 10px 13px 15px 13px;
  box-sizing: border-box;
}
.twoinfo {
  font-size: 16px;
  font-family: FZLanTingHei-DB-GBK;
  font-weight: 400;
  color: #0981ff;
  margin-bottom: 6px;
}
.twophone {
  font-size: 14px;
  font-family: FZLanTingHei-M-GBK;
  font-weight: 400;
  color: #333333;
  margin-bottom: 6px;
}
.loacinfo {
  font-size: 16px;
  font-family: FZLanTingHei-M-GBK;
  font-weight: 400;
  color: #333333;
  margin-top: 24px;
}
.three {
  min-height: 100px;
  background: #f9fbfd;
  border: 1px solid #c1d1ff;
  border-radius: 10px;
  margin-top: 12px;
  margin-bottom: 16px;
  max-height: 200px;
  overflow: auto;
  padding: 20px 20px;
  box-sizing: border-box;
  padding-bottom: 0;
}

.three::-webkit-scrollbar {
  width: 3px;
  // display: none;
}
/*定义滚动条轨道*/
.three::-webkit-scrollbar-track {
  border-radius: 10px;
  // display: none;
}
/*定义滑块*/
.three::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background: rgba(27, 140, 236, 0.5);
  display: none;
}
.dainzhang {
  background: #fba516;
  border-radius: 4px;
  padding: 2px;
  line-height: 20px;
  font-size: 12px;
  color: #ffffff;
  margin-right: 6px;
}
.channeltype2 {
  height: 16px;
  background: #fba516;
  border-radius: 4px;
  padding: 2px;
  line-height: 20px;
  font-size: 12px;
  color: #ffffff;
  margin-right: 6px;
}
.images-box {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.images-box>img {
  width: 70px;
  height: 70px;
  margin-bottom: 10px;
}

.images-box>span {
  color: #0981ff;
  cursor: pointer;
}
.img-box {
  margin-bottom: 20px;

  // 图片
  .imgs-num {
    text-align: center;
    margin: 5px 0;
    font-weight: bold;
  }

  .img-tips-box {
    display: flex;
    height: 30px;
    width: max-content;
    border: 1px solid #0981ff;

    .img-tips {
      width: 80px;
      text-align: center;
      line-height: 30px;
      box-sizing: border-box;
      cursor: pointer;
    }

    .img-tips-default {
      background: #fff;
      color: #0981ff;
    }

    .img-tips-choose {
      background: #0981ff;
      color: #fff;
    }
  }
}
.sec_img{
  display: flex;
  justify-content: center;
}
</style>
